/* eslint-disable no-undef */
import "../Styles/CartProcess.css";
import "../Styles/Checkout.css";

import { useState, useEffect, useRef } from "react";
import { Frames, CardNumber, ExpiryDate, Cvv } from "frames-react";
import { BsCash, BsPhoneFlip } from "react-icons/bs";
import { BsCreditCard } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { TiTick } from "react-icons/ti";
import {
  Get_Basket,
  checkout_step,
  checkout_step_details,
  payment_methods,
} from "../api-nano";

function CartProcess31(props) {
  const [active, setActive] = useState(0);
  const { t, i18n } = useTranslation();
  const [cart, setCart] = useState();
  const history = useNavigate();
  const [deliveryPrice, setDeliveryPrice] = useState();
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [wallet, setWallet] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState();
  const [onlineType, setOnlineType] = useState();

  const [msgEn, setMsgEn] = useState();
  const [msgAr, setMsgAr] = useState();
  const [msgEn2, setMsgEn2] = useState();
  const [msgAr2, setMsgAr2] = useState();
  const [errorMsgModel, setErrorMsgModel] = useState(false);
  const [errorMsgModel2, setErrorMsgModel2] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    localStorage.getItem("paymentMethod")
      ? localStorage.getItem("paymentMethod")
      : null
  );

  const [createBool, setCreateBool] = useState(false);
  const [discount, setDiscount] = useState(false);
  const [freeMeal, setFreeMeal] = useState(false);
  const [offer, setOffer] = useState(
    localStorage.getItem("offer") ? localStorage.getItem("offer") : false
  );
  const [phone, setPhone] = useState("");
  const [invalid, setInvalid] = useState(false);
  const [breakdown, setBreakdown] = useState();
  const [cardValid, setCardValid] = useState(false);

  const [code, setCode] = useState(
    localStorage.getItem("promo") ? localStorage.getItem("promo") : ""
  );
  const [tipAmount, setTipAmount] = useState("");

  const [currency, setCurrency] = useState({
    ar: localStorage.getItem("currencyAr"),
    en: localStorage.getItem("currencyEn"),
  });

  const codeRef = useRef();
  const tipRef = useRef();

  const walletRef = useRef();
  const cashRef = useRef();
  const tapRef = useRef();

  const getProductionUrl = () => {
    return 'https://rydan-res.com';
  };


  useEffect(() => {
    const token = localStorage.getItem("token");
    localStorage.removeItem("cardToken");

    const delivery = localStorage.getItem("order_details");
    setDeliveryPrice(JSON.parse(delivery).delivery);

    Get_Basket(token)
      .then((response) => {
        console.log("the carts is", response);
        const data = response.data;
        setCart(response.data);

        const addressData = JSON.parse(localStorage.getItem("addressData") || "{}");
        const shopId = localStorage.getItem("orderBranch");
        const orderType = localStorage.getItem("orderType");

        const detailsData = {
          shipping_address_1: addressData.shipping_address_1 || "اب, اليمن",
          shipping_country: addressData.shipping_country || "YE",
          shipping_state: addressData.shipping_state || "428",
          shop_id: shopId || 4,
          order_type: orderType || "delivery_shop",
        };

        checkout_step_details(token, detailsData)
          .then((shippingResponse) => {
            console.log("shipping methods:", shippingResponse);
      
            
            // console.log(shippingResponse)
            // console.log("-------------",shippingResponse.data.cart_totals?.tax?.title)
            // console.log("-------------",shippingResponse.data.cart_totals?.total?.value)
            let breakDown = {
              originalPrice: shippingResponse.data.cart_totals?.subtotal.value,
              tax: shippingResponse.data.cart_totals?.tax?.title,
              taxValue: shippingResponse.data.cart_totals?.tax?.value,
              deliveryPrice: shippingResponse.data.cart_totals?.shipping_total.value,
              tipAmount: shippingResponse.data.cart_totals?.tip.value,
              totalPrice: shippingResponse.data.cart_totals?.total.value
            };
            setBreakdown(breakDown);
            setLoading(false);
            payment_methods(token)
              .then((response) => {
                console.log("the payment methods is", response);

                setPaymentMethod(response.data.data);
                if (localStorage.getItem("paymentMethod")) {
                  setSelectedOption(localStorage.getItem("paymentMethod"));
                } else {
                  // setSelectedOption("cash");
                }
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((error) => {
            setLoading(false);
          });
      });
  }, []);

  async function handleOffer() {
    setCreateBool(false);
    const token = localStorage.getItem("token");
    setErrorMsgModel2(false);
    setOffer(false);
    localStorage.setItem("offer", false);

    if (selectedOption == null) {
      setErrorMsgModel(true);
      setMsgEn("Please choose payment method");
      setMsgAr("قم باختيار طريقة الدفع");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrorMsgModel(false);
      }, 2000);
    } else {
      const storedAddressData = JSON.parse(localStorage.getItem("addressData") || "{}");
      const shopId = localStorage.getItem("orderBranch");
      const orderType = localStorage.getItem("orderType");

      const data = {
        step: "details_shiping_coupon",
        shipping_address_1: storedAddressData.shipping_address_1 || "",
        shipping_country: storedAddressData.shipping_country || "YE",
        shipping_state: storedAddressData.shipping_state || "428",
        coupon_code: codeRef.current.value,
        tip_amount: tipRef.current.value,
        shop_id: shopId || 4,
        order_type: orderType || "delivery_shop"
      };

      try {
        const response = await checkout_step_details(token, data);
        console.log("the coupon's response step is", response);

        if (response.data.code === 200) {
            // Update the breakdown state with the new data
            const newBreakdown = {
              originalPrice: response.data.cart_totals.subtotal.value,
              tax: response.data.cart_totals.tax.title,
              taxValue: response.data.cart_totals.tax.value,
              deliveryPrice: response.data.cart_totals.shipping_total.value,
              tipAmount: response.data.cart_totals.tip.value,
              totalPrice: response.data.cart_totals.total.value
            };
            setBreakdown(newBreakdown);
            setTipAmount(tipRef.current.value); // Update the tip amount state
        } else {
          // Handle any other status codes if needed
        }
      } catch (err) {
        console.log("the error", err);
        setErrorMsgModel(true);
        setMsgEn("An error occurred while processing your request");
        setMsgAr("حدث خطأ أثناء معالجة طلبك");
        setTimeout(function () {
          setErrorMsgModel(false);
        }, 2000);
      }
    }
  }

  function checkOffer(cardToken) {
    const token = localStorage.getItem("token");
    setSubmitLoading(true);
    
    if (selectedOption == null) {
      setErrorMsgModel(true);
      setMsgEn("Please choose payment method");
      setMsgAr("برجاء اختيار طريقة الدفع");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrorMsgModel(false);
      }, 2000);
    } else {
      const tipAmount = tipRef.current ? tipRef.current.value : "0";
      
      const selectedPaymentMethod = paymentMethod?.find(
        method => method.payment_provider === selectedOption
      );
      
      if (!selectedPaymentMethod) {
        setErrorMsgModel(true);
        setMsgEn("Payment method not found");
        setMsgAr("طريقة الدفع غير موجودة");
        setSubmitLoading(false);
        setTimeout(function () {
          setErrorMsgModel(false);
        }, 2000);
        return;
      }
      
      const data = {
        ...JSON.parse(localStorage.getItem("addressData")),
        payment_method_id: selectedPaymentMethod.id,
        step: "pay",
        tip_amount: tipAmount,
        shop_id: localStorage.getItem("orderBranch") || 4,
        order_type: localStorage.getItem("orderType") || "delivery_shop"
      };
      
      // ✅ الحل البسيط: استخدم دومين الإنتاج دائماً
      if (selectedPaymentMethod.payment_provider === "thawanipay") {
        const productionUrl = getProductionUrl();
        data.callback_success_url = `${productionUrl}/payment/success`;
        data.callback_error_url = `${productionUrl}/payment/error`;
        
        console.log("✅ Callback URLs:", {
          success: data.callback_success_url,
          error: data.callback_error_url
        });
      }

      checkout_step(token, data, "pay")
        .then((response) => {
          console.log("Checkout response:", response);
          
          if (response.data.code != 200) {
            setErrorMsgModel(true);
            setMsgAr(response.data.error);
            setMsgEn(response.data.message);
            setSubmitLoading(false);
            setTimeout(function () {
              setErrorMsgModel(false);
            }, 5000);
          } else {
            const paymentResult = response.data?.process_data?.paymentResult;
            
            if (
              paymentResult && 
              paymentResult.successful === true &&
              paymentResult.redirect === true &&
              paymentResult.redirectUrl &&
              paymentResult.redirectUrl.trim() !== ""
            ) {
              console.log("Redirecting to:", paymentResult.redirectUrl);
              window.location.href = paymentResult.redirectUrl;
              return;
            }
            
            if (selectedPaymentMethod.payment_provider === "thawanipay" && paymentResult?.redirectUrl) {
              console.log("Redirecting to thawani:", paymentResult.redirectUrl);
              window.location.href = paymentResult.redirectUrl;
              return;
            }
            
            history("/cart-process-4", { 
              state: { 
                message: "تمت عملية الطلب بنجاح",
                success: true 
              }
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setErrorMsgModel(true);
          setMsgAr("حدث خطأ أثناء معالجة الطلب");
          setMsgEn("An error occurred");
          setSubmitLoading(false);
          setTimeout(function () {
            setErrorMsgModel(false);
          }, 5000);
        });
    }
  }

  function createOrder(cardToken) {
    setDiscount(false);
    setFreeMeal(false);
    const token = localStorage.getItem("token");
    const detail = JSON.parse(localStorage.getItem("order_details"));
    setSubmitLoading(true);

    if (selectedOption == null) {
      setErrorMsgModel(true);
      setMsgEn("Please choose payment method");
      setMsgAr("برجاء اختيار طريقة الدفع");
      setSubmitLoading(false);
      setTimeout(function () {
        setErrorMsgModel(false);
      }, 2000);
    } else {
      const selectedPaymentMethod = paymentMethod?.find(
        method => method.payment_provider === selectedOption
      );
      
      if (!selectedPaymentMethod) {
        setErrorMsgModel(true);
        setMsgEn("Payment method not found");
        setMsgAr("طريقة الدفع غير موجودة");
        setSubmitLoading(false);
        setTimeout(function () {
          setErrorMsgModel(false);
        }, 2000);
        return;
      }
      
      // ... الكود الموجود للـ data2 ...
      
      const data = JSON.parse(localStorage.getItem("addressData"));
      
      const checkoutData = {
        ...data,
        payment_method_id: selectedPaymentMethod.id,
        step: "pay",
        tip_amount: tipRef.current.value,
        shop_id: localStorage.getItem("orderBranch") || 4,
        order_type: localStorage.getItem("orderType") || "delivery_shop"
      };
      
      // ✅ نفس الحل البسيط
      if (selectedPaymentMethod.payment_provider === "thawanipay") {
        const productionUrl = getProductionUrl();
        checkoutData.callback_success_url = `${productionUrl}/thawanipay/success`;
        checkoutData.callback_error_url = `${productionUrl}/thawanipay/error`;
        checkoutData.return_url = `${productionUrl}/thawanipay/success`;
      }

      checkout_step(token, checkoutData, "pay")
        .then((response) => {
          console.log("Response:", response);
          
          const paymentResult = response.data?.process_data?.paymentResult;
          
          if (
            paymentResult && 
            paymentResult.successful === true &&
            paymentResult.redirect === true &&
            paymentResult.redirectUrl &&
            paymentResult.redirectUrl.trim() !== ""
          ) {
            console.log("Redirecting:", paymentResult.redirectUrl);
            window.location.href = paymentResult.redirectUrl;
            return;
          }
          
          if (response.data.redirect_url && response.data.redirect_url.trim() !== "") {
            console.log("Redirecting:", response.data.redirect_url);
            window.location.href = response.data.redirect_url;
            return;
          }
          
          localStorage.setItem("transactionType", "order");
          localStorage.removeItem("promo");
          localStorage.removeItem("paymentMethod");
          localStorage.removeItem("process");
          localStorage.removeItem("timeNow");
          localStorage.removeItem("cartMessage");
          localStorage.removeItem("offer");
          localStorage.removeItem("orderDate");
          localStorage.removeItem("deliveryType");

          props.setCartChange(!props.cartChange);

          setMsgAr("عملية الدفع تمت بنجاح");
          setMsgEn("Payment completed successfully");
          setSubmitLoading(false);
          setTimeout(function () {
            props.setNav(3);
            localStorage.setItem("process", 3);
          }, 2000);
        })
        .catch((error) => {
          setMsgAr("حدث فشل في عملية الدفع");
          setMsgEn("Payment failed");
          setSubmitLoading(false);
          setTimeout(function () {
            props.setCartChange(!props.cartChange);
            history("/payment/error");
          }, 2000);
        });
    }
  }

  const handleOptionChange = (changeEvent, n) => {
    console.log("the payment method is ", paymentMethod);
    console.log(changeEvent.target.value);
    localStorage.setItem("paymentMethod", changeEvent.target.value);
    setSelectedOption(changeEvent.target.value);
    setActive(n);
  };

  const handleBack = () => {
    props.setNav(1);
    localStorage.setItem("process", 1);
  };

  return (
    <div className="cartProcess">
      {" "}
      {loading ? (
        <div className="loader">
          <BeatLoader color={"#ffc010"} loading={loading} size={30} />
        </div>
      ) : (
        <>
          <div className="container-fluid fluid ">
            <div className="cpMiddle-title2">
              <p> {t("process.details")} </p>{" "}
              <div className="cpPayment">
                <div className="row ">
                  <div
                    style={{
                      display: "block",
                      position: "relative",
                    }}
                    className="col-md-6 cpPayment-div2 "
                  >
                    <p> {t("process.payment_type")} </p>{" "}

                    {/* To do : fix this to work withall code  */}
                    {paymentMethod?.map((paymentM, index) => (
                      <div
                        key={index}
                        className={
                          localStorage.getItem("paymentMethod") === paymentM.payment_provider
                            ? "activeChoice"
                            : ""
                        }
                        onClick={() => {
                          // Set the appropriate ref based on index
                          if (index === 0 && walletRef.current) walletRef.current.click();
                          if (index === 1 && cashRef.current) cashRef.current.click();
                          if (index === 2 && tapRef.current) tapRef.current.click();
                        }}
                      >
                        <label>
                          {paymentM.payment_provider === "thawanipay" ? (
                            <BsPhoneFlip size={23} className="labelIcon" />
                          ) : paymentM.payment_provider === "CacheOnDelivery" ? (
                            <BsCash size={23} className="labelIcon" />
                          ) : (
                            <BsCreditCard size={23} className="labelIcon" />
                          )}
                          {paymentM.name}
                        </label>

                        <input
                          value={paymentM.payment_provider}
                          id={`payment-${paymentM.id}`}
                          onChange={(e) => handleOptionChange(e, paymentM.id)}
                          type="radio"
                          name="payment"
                          ref={index === 0 ? walletRef : index === 1 ? cashRef : tapRef }
                          defaultChecked={
                            localStorage.getItem("paymentMethod") === paymentM.payment_provider
                          }
                        />
                      </div>
                    ))}

                    <div>
                      <p> {t("process.code")} </p>
                      <div className="promo">
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <input
                            type="text"
                            ref={codeRef}
                            className={errorMsgModel2 ? "invalid" : null}
                            value={code}
                            onChange={(e) => {
                              setCode(e.target.value);
                              localStorage.setItem("promo", e.target.value);
                            }}
                          />{" "}
                          {offer && localStorage.getItem("showIcn") == "true" ? (
                            <TiTick
                              size={30}
                              className={
                                i18n.language == "ar" ? "tick" : "tickEn"
                              }
                            />
                          ) : null}
                        </div>{" "}
                        <button onClick={handleOffer}>
                          {" "}
                          {t("profile.confirm")}{" "}
                        </button>{" "}
                      </div>
                    </div>
                    {" "}
                    {/* !!!!!! Can you fix this div tag belo to add a tip_amount to data !!!!!!!!!!!!!!!!11111 */}

                    <div>
                        <p>{t("process.tip")}</p>
                        <div className="tip">
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              ref={tipRef}
                              className={errorMsgModel2 ? "invalid" : null}
                              value={tipAmount}
                              onChange={(e) => {
                                setTipAmount(e.target.value);
                                // localStorage.setItem("tip", e.target.value);
                              }}
                            />
                            {offer && localStorage.getItem("showIcn") == "true" ? (
                              <TiTick
                                size={30}
                                className={i18n.language == "ar" ? "tick" : "tickEn"}
                              />
                            ) : null}
                          </div>
                          <button onClick={handleOffer}>{t("profile.confirm")}</button>
                        </div>
                      </div>

                    {" "}
                    {i18n.language == "ar" ? (
                      <span
                        style={{
                          fontSize: "14px",
                          color: "brown",
                        }}
                      >
                        {" "}
                        {errorMsgModel2 ? msgAr2 : null}{" "}
                      </span>
                    ) : (
                      <span
                        style={{
                          fontSize: "14px",
                          color: "brown",
                        }}
                      >
                        {" "}
                        {errorMsgModel2 ? msgEn2 : null}{" "}
                      </span>
                    )}
                    <div
                      style={{
                        minHeight: "100px",
                      }}
                      className={
                        errorMsgModel ? "addAlert " : " addAlert alert-hidden "
                      }
                    >
                      <span
                        style={{
                          color: "brown",
                        }}
                      >
                        {" "}
                        {i18n.language == "en" ? msgEn : msgAr}{" "}
                      </span>
                    </div>
                    <span> </span>{" "}
                  </div>
                  <div className="col-md-6 cpPayment-div1">
                    <div
                      style={{
                        padding: "1em",
                      }}
                    >
                      <p className="cpPayment-div1-title">
                        {" "}
                        {t("process.payment_summary")}{" "}
                      </p>{" "}
                      <div className="cpMoneyBreakdown">
                        <div>
                          <p> {t("process.price")} </p>{" "}
                          <p className="cpMoney">
                            {" "}
                            {breakdown?.originalPrice?.toFixed(2)} {"ريال"}{" "}
                          </p>
                        </div>{" "}
                        <div>
                          <p>
                            {" "}
                            {t("process.tax")}
                            {breakdown?.tax}{" "}
                          </p>

                          <p className="cpMoney">
                            {" "}
                            {breakdown?.taxValue?.toFixed(2)} {"ريال"}{" "}
                          </p>
                        </div>{" "}
                        
                        {/* Todo: add delivery price and calculated with total price  */}
                        {breakdown && (
                        <div>
                          <p> {t("process.delivery_charge")} </p>{" "}
                          <p className="cpMoney">
                            {" "}
                            {breakdown.deliveryPrice}  {"ريال"}{" "}
                          </p>
                        </div>
                      )}

                    {/* Todo: add delivery price and calculated with total price  */}
                    {breakdown && (
                      <div>
                        <p>{t("process.tip")}</p>
                        <p className="cpMoney">
                          {breakdown.tipAmount} {"ريال"}
                        </p>
                      </div>
                      )}

                        {offer &&
                        (localStorage.getItem("offerType") == "discount" ||
                          localStorage.getItem("offerType") ==
                            "freeMealsDiscount" ||
                          localStorage.getItem("offerType") ==
                            "discountCashBack") ? (
                          <div>
                            <p> {t("process.discount")} </p>{" "}
                            <p className="cpMoney">
                              {" "}
                              {parseFloat(
                                localStorage.getItem("discAmount")
                              )?.toFixed(2)}{" "}
                              {"ريال"}{" "}
                            </p>
                          </div>
                        ) : null}
                      </div>{" "}
                      <hr />
                      <div
                        style={{
                          transform: "none",
                        }}
                        className="cpTotaldiv"
                      >
                        <p className="cpTotalP"> {t("process.total")} </p>{" "}
                        <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                          <p className="cpTotal">
                            {" "}
                            {offer &&
                            (localStorage.getItem("offerType") == "discount" ||
                              localStorage.getItem("offerType") ==
                                "freeMealsDiscount" ||
                              localStorage.getItem("offerType") ==
                                "discountCashBack")
                              ? localStorage.getItem("discountPrice")
                              : breakdown?.totalPrice?.toFixed(2)}{" "}
                          </p>{" "}
                          <p className="cpCurrency"> {"ريال"} </p>{" "}
                        </div>
                      </div>{" "}
                      {selectedOption == "checkout" ||
                      (selectedOption == "wallet" &&
                        (offer &&
                        (localStorage.getItem("offerType") == "discount" ||
                          localStorage.getItem("offerType") ==
                            "discountCashBack" ||
                          localStorage.getItem("offerType") ==
                            "freeMealsDiscount")
                          ? wallet < localStorage.getItem("discountPrice")
                          : wallet < breakdown.totalPrice) &&
                        onlineType == "checkout") ? (
                        <div
                          className="creditCard"
                          style={{
                            marginTop: "1.5em",
                          }}
                        >
                          <Frames
                            cardValidationChanged={(e) => {
                              setCardValid(e.isValid);
                            }}
                            config={{
                              publicKey: "pk_sbox_wxn7ld2c4dskxkd4kcpiilwo2uo",
                              schemeChoice: true,
                            }}
                            cardTokenized={(e) => {
                              checkOffer(e.token);
                            }}
                          >
                            <CardNumber />
                            <div className="date-and-code">
                              <ExpiryDate />
                              <Cvv />
                            </div>
                            {/* Or if you want to use single frames: */}{" "}
                            {/* <CardFrame /> */}
                            {submitLoading ? (
                              <div
                                style={{
                                  height: "6vh",
                                  marginTop: "2em",
                                  alignItems: "center",
                                  flexDirection: "column",
                                }}
                                className="loader"
                              >
                                <BeatLoader
                                  color={"#ffc010"}
                                  loading={submitLoading}
                                  size={30}
                                />{" "}
                                <p className="paymentLoad">
                                  {" "}
                                  {t("payment.processing")}{" "}
                                </p>{" "}
                              </div>
                            ) : (
                              <button
                                disabled={!cardValid}
                                id="pay-button"
                                onClick={() => {
                                  setSubmitLoading(true);
                                  if (localStorage.getItem("cardToken")) {
                                    checkOffer(
                                      localStorage.getItem("cardToken")
                                    );
                                  } else {
                                    Frames.submitCard();
                                  }
                                }}
                              >
                                {t("process.confirm_order")}{" "}
                              </button>
                            )}{" "}
                          </Frames>{" "}
                        </div>
                      ) : null}{" "}
                    </div>{" "}
                  </div>{" "}
                </div>{" "}
              </div>{" "}
            </div>
            {selectedOption == "checkout" ||
            (selectedOption == "wallet" &&
              (offer &&
              (localStorage.getItem("offerType") == "discount" ||
                localStorage.getItem("offerType") == "discountCashBack" ||
                localStorage.getItem("offerType") == "freeMealsDiscount")
                ? wallet < localStorage.getItem("discountPrice")
                : wallet < breakdown?.totalPrice) &&
              onlineType == "checkout") ? null : (
              <>
                {" "}
                {submitLoading ? (
                  <div
                    style={{
                      height: "23vh",
                      alignItems: "unset",
                    }}
                    className="loader"
                  >
                    <BeatLoader
                      color={"#ffc010"}
                      loading={submitLoading}
                      size={30}
                    />
                  </div>
                ) : (

                  <div className="cartNext cartBack">
                  {/* Todo: Add back button on Sales basket on cart */}
                    <button onClick={handleBack}>
                      {t("process.back")}{" "}
                    </button>

                    <button 
                      onClick={checkOffer} 
                      // disabled={submitLoading || !selectedOption}
                    >
                      {submitLoading ? t("process.processing") : t("process.confirm_order")}
                    </button>
                  </div>
                )}{" "}
              </>
            )}{" "}
          </div>{" "}
        </>
      )}{" "}
    </div>
  );
}

export default CartProcess31;
